import { TranslateService } from '@ngx-translate/core';
import { APPEAL_STATUS_OPTIONS } from './appeals-statuses-data';

export function getAppealCurrentLangKey(tr: TranslateService): string {
  const currentLang = (tr && (tr.currentLang || tr.defaultLang)) || 'en-US';
  if (currentLang === 'ar-LB') return 'ar-LB';
  return currentLang;
}

export function getAppealStatusLabel(status: number, tr: TranslateService): string {
  const option = APPEAL_STATUS_OPTIONS.find(o => o.value === status);
  if (!option) {
    return tr ? tr.instant('Unknown') : 'Unknown';
  }

  const langKey = getAppealCurrentLangKey(tr);
  const names = (option.names || {}) as Record<string, string>;

  const direct = names[langKey];
  if (direct && direct.trim()) {
    return direct;
  }

  const fallbackLanguages = ['ru-RU', 'en-US', 'uz-Latn-UZ', 'uz-Cyrl-UZ', 'ar-LB', 'fr-FR'];
  for (const l of fallbackLanguages) {
    const v = names[l];
    if (v && v.trim()) return v;
  }

  return option.label || (tr ? tr.instant('Unknown') : 'Unknown');
}

export function getAppealStatusSeverity(status: number): string {
  switch (status) {
    case 0: return 'info';
    case 1: return 'warning';
    case 2: return 'danger';
    case 3: return 'success';
    default: return 'secondary';
  }
}

